import { Host, h } from "@stencil/core";
export class DnnTabs {
    constructor() {
        this.tabTitles = [];
        this.selectedTabTitle = "";
    }
    componentDidLoad() {
        requestAnimationFrame(() => {
            this.updateTitles();
            this.showFirstTab();
        });
    }
    getTabs() {
        return this.component.shadowRoot.querySelector("slot").assignedElements();
    }
    updateTitles() {
        const tabs = this.getTabs();
        tabs.forEach(tab => this.tabTitles = [...this.tabTitles, tab.tabTitle]);
    }
    showFirstTab() {
        const tab = this.getTabs()[0];
        tab.show();
        this.selectedTabTitle = tab.tabTitle;
    }
    showTab(tabTitle) {
        const tabs = this.getTabs();
        tabs.forEach(tab => {
            if (tab.tabTitle == tabTitle) {
                tab.show();
                return;
            }
            tab.hide();
        });
        this.selectedTabTitle = tabTitle;
    }
    render() {
        return (h(Host, { key: '9df3e12077a1b0eab806b179d9b79bc669fe14e8', ref: el => this.component = el }, h("div", { key: '0a2dc82e52e8c54a1b322bf5b87f256440e77050', class: "tabTitles" }, this.tabTitles.map(tabTitle => h("button", { class: this.selectedTabTitle == tabTitle ? "visible" : "", onClick: () => this.showTab(tabTitle) }, tabTitle))), h("div", { key: '7a5112422f4a72f88f7c0b9919e035e26ff3cebf', class: "currentTab" }, h("slot", { key: '5a64aab32ad3bb5165778b241ce0d68cd87f42f0' }))));
    }
    static get is() { return "dnn-tabs"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-tabs.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-tabs.css"]
        };
    }
    static get states() {
        return {
            "tabTitles": {},
            "selectedTabTitle": {}
        };
    }
}
//# sourceMappingURL=dnn-tabs.js.map
